import { validateResponse } from "../../../../response.js";
import { authHeader, acceptJson } from "../../../../shared.js";
import { subscriptionSpec } from "./specs.js";
async function details(apiUrl, accessToken, request) {
  return validateResponse(
    subscriptionSpec,
    await fetch(
      `${apiUrl}/customers/customer/${encodeURIComponent(request.customerId)}/subscription/${request.subscriptionId}`,
      {
        method: "GET",
        headers: {
          ...acceptJson,
          ...authHeader(accessToken)
        }
      }
    )
  );
}
export {
  details
};
//# sourceMappingURL=details.js.map
